import firebase from '@firebase/app'
import '@firebase/database'

const state = {
  notes: [],
  notesRef: null
}

const getters = {
  notes (state) {
    return state.notes
  },
  notesRef (state) {
    return state.notesRef
  },
  notesByUser (state) {
    return (uid) => {
      const userNotes = []
      for (let note of state.notes) {
        if (note.uid === uid) userNotes.push({...note})
      }
      return userNotes
    }
  }
}

const mutations = {
  setNotes (state, payload) {
    state.notes = payload
  },
  setNotesRef (state, payload) {
    state.notesRef = payload
  }
}

const actions = {
  loadNotes: (store) => new Promise((resolve, reject) => {
    const ref = firebase.database().ref('notes')
    ref.on('value', snapshot => {
      const notes = []
      snapshot.forEach(n => {
        notes.push({key: n.key, ...n.val()})
      })
      store.commit('setNotes', notes)
      store.commit('setNotesRef', ref)
      resolve()
    })
  }),
  createNote: (store, payload) => new Promise((resolve, reject) => {
    const newNote = {...payload}
    store.getters.notesRef.push(newNote).then(() => {
      resolve()
    }).catch(err => {
      reject(err)
    })
  }),
  updateNote: (store, payload) => new Promise((resolve, reject) => {
    const newNote = {...payload}
    store.getters.notesRef.child(newNote.key).set(newNote).then(() => {
      resolve()
    }).catch(err => {
      reject(err)
    })
  }),
  deleteNote: (store, payload) => new Promise((resolve, reject) => {
    const toDelete = {...payload}
    store.getters.notesRef.child(toDelete.key).remove().then(() => {
      resolve()
    }).catch(err => {
      reject(err)
    })
  }),
  resetNotes: (store) => new Promise((resolve, reject) => {
    if (store.getters.notesRef) store.getters.notesRef.off()
    store.commit('setNotesRef', null)
    store.commit('setNotes', [])
    resolve()
  })
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/users/notes.js